import apiService from '../apiService';

export const getActivitySetting = async () => {
    return apiService.GET('/api/admin/console/ice-fire/activity-setting');
};

export const updateActivitySetting = async (payload) => {
    return apiService.PUT(
        '/api/admin/console/ice-fire/activity-setting',
        payload
    );
};

export const uploadGuideSlideImage = async (file) => {
    const data = new FormData();
    data.append('image', file);

    return apiService.POST(
        '/api/admin/console/ice-fire/activity-setting/guide-slide-image',
        data
    );
};
